import {
  SET_APP_RATINGS_FILTERS,
  SET_BRAND_PERFORMANCE_IMAGE_ATTRIBUTE_FILTERS,
  SET_BRAND_PERFORMANCE_OAO_FILTERS,
  SET_BRAND_HEALTH_INDEX_FILTERS,
  SET_BRAND_PERFORMANCE_VOLUME_FILTERS,
  SET_CCS_FILTERS,
  SET_CPO_OPERATIONAL_FILTERS,
  SET_ECOMMERCE_FILTERS,
  SET_EUROPE_ACTIVATION_FILTERS,
  SET_EUROPE_ACTIVATION_MARKET_GROUPS,
  SET_EXECUTIVE_SUMMARY_FILTERS,
  SET_FILTERS,
  SET_FILTER_OPTIONS_LIST,
  SET_GEO_SCOPE,
  SET_JOURNEY_EXCLLENCE_FILTERS,
  SET_MIDAS_FILTERS,
  SET_MSRP_FILTERS,
  SET_MTM_MARKETS,
  SET_NEW_PURCHASE_FUNNEL_FILTERS,
  SET_OCE_ALL_MARKET_REGIONS,
  SET_OCE_ALL_REGIONS,
  SET_OCE_CHANNELS_BY_BRAND_FILTERS,
  SET_OCE_MARKETS_BY_BRAND_FILTERS,
  SET_OCE_MODEL_BY_BRAND_FILTERS,
  SET_PRODUCT_MARKETING_OPTIMIZATION_FILTERS,
  SET_PRODUCT_PERFORMANCE_FILTERS,
  SET_SEO_GEOGRAPHY,
  SET_TOP_FLOP_FILTERS,
  SET_UAE_ACTIVATION_FILTERS,
  SET_USER_GROUP_MARKETS,
  SET_USE_OWNERSHIP_FILTERS,
  SET_VOC_FILTERS,
  SET_BRAND_SEGMENT_VOLUME_FILTERS,
  SET_BRAND_MARKET_SHARE_FILTERS,
  SET_SALES_BY_VOLUME_FILTERS,
  SET_BRAND_KPI_TREND_FILTERS,
  SET_BRAND_KPI_SUMMARY_FILTERS,
  SET_BRAND_PERFORMANCE_SOV_SOM_FILTERS,
  SET_BRAND_PERFORMANCE_PURCHASE_FUNNEL_FILTERS,
  SET_BRAND_PERFORMANCE_IMAGE_SNAPSHOT_FILTERS,
  SET_MONTHLY_TABLE_FOR_DOWNLOAD_FILTERS,
  SET_YEARLY_TABLE_FOR_DOWNLOAD_FILTERS,
  SET_QUARTERLY_TABLE_FOR_DOWNLOAD_FILTERS,
  SET_BRAND_PERFORMANCE_NIM_FILTERS,
  SET_BRAND_PERFORMANCE_NIM_LATEST_FILTERS,
  SET_BRAND_PERFORMANCE_RV_FILTERS,
  SET_BRAND_PERFORMANCE_TPVA_FILTERS,
  SET_BRAND_PERFORMANCE_TP_FILTERS,
  SET_BRAND_PERFORMANCE_TECH_AWARENESS_FILTERS,
  SET_BUZZ_TRACKING_FILTERS,
} from "../actions/actionTypes";
import { SET_ASEAN_ACTIVATION_FILTERS } from "../actions/actionTypes/AseanActivationTypes";

const initialState = {
  data: [],
  filterOptions: {},
  cockpit_data: {},
  europe_activation_filters: {},
  app_ratings_filters: {},
  europe_activation_market_groups: [],
  user_group_markets: [],
  purchase_funnel_markets: [],
  seo_markets: [],
  mtm_markets: [],
  purchase_funnel_filters: [],
  top_flop_filters: [],
  product_marketing_optimization_filters: {},
  midas_filters: {},
  geo_scope: {},
  product_performance_filters: {},
  uae_activation_filters: {},
  asean_activation_filters: {},
  voc_filters: {},
  cpo_operational_filters: {},
  ecommerce_filters: {},
  msrp_filters: {},
  journey_excellence_filters: {},
  use_ownership_filters: {},
  oce_all_market_regions: {},
  oce_all_regions: [],
  oce_model_by_brand_filters: {},
  oce_markets_by_brand_filters: {},
  oce_channels_by_brand_filters: {},
  brand_performance_volume_filters: {},
  brand_performance_oao_filters: {},
  brand_health_index_filters: {},
  brand_performance_image_attributes_filters: {},
  brand_segment_volume_filters: {},
  brand_market_share_filters: {},
  brand_sales_by_volume_filters: {},
  brand_kpi_trend_filters: {},
  brand_kpi_summary_filters: {},
  brand_performance_sov_som_filters: {},
  brand_performance_purchase_funnel_filters: {},
  brand_performance_image_snapshot_filters: {},
  brand_performance_monthly_table_for_download_filters: {},
  brand_performance_yearly_table_for_download_filters: {},
  brand_performance_quarterly_table_for_download_filters: {},
  brand_performance_nim_filters: {},
  brand_performance_nim_latest_filters: {},
  brand_performance_rv_filters: {},
  brand_performance_tpva_filters: {},
  brand_performance_tp_filters: {},
  brand_performance_tech_awareness_filters: {},
  buzz_tracking_filters: {},
  executive_summary_filters: {},
};

const filtersReducer = (
  state = initialState,
  action: {
    filter: string;
    type: string;
    payload: any;
  }
) => {
  switch (action.type) {
    case SET_FILTERS:
      return { ...state, data: action.payload };

    case SET_GEO_SCOPE:
      return { ...state, geo_scope: action.payload };

    case SET_CCS_FILTERS:
      return { ...state, cockpit_data: action.payload };

    case SET_EUROPE_ACTIVATION_FILTERS:
      return { ...state, europe_activation_filters: action.payload };

    case SET_APP_RATINGS_FILTERS:
      return { ...state, app_ratings_filters: action.payload };

    case SET_FILTER_OPTIONS_LIST:
      return { ...state, filterOptions: { ...state.filterOptions, [action.filter]: action.payload } };

    case SET_EUROPE_ACTIVATION_MARKET_GROUPS:
      return { ...state, europe_activation_market_groups: action.payload };

    case SET_USER_GROUP_MARKETS:
      return { ...state, user_group_markets: action.payload };

    case SET_MTM_MARKETS:
      return { ...state, mtm_markets: action.payload };

    case SET_SEO_GEOGRAPHY:
      return { ...state, seo_markets: action.payload };

    case SET_NEW_PURCHASE_FUNNEL_FILTERS:
      return { ...state, purchase_funnel_filters: action.payload };

    case SET_TOP_FLOP_FILTERS:
      return { ...state, top_flop_filters: action.payload };

    case SET_PRODUCT_MARKETING_OPTIMIZATION_FILTERS:
      return { ...state, product_marketing_optimization_filters: action.payload };

    case SET_MIDAS_FILTERS:
      return { ...state, midas_filters: action.payload };

    case SET_PRODUCT_PERFORMANCE_FILTERS:
      return { ...state, product_performance_filters: action.payload };

    case SET_UAE_ACTIVATION_FILTERS:
      return { ...state, uae_activation_filters: action.payload };

    case SET_ASEAN_ACTIVATION_FILTERS:
      return { ...state, asean_activation_filters: action.payload };

    case SET_VOC_FILTERS:
      return { ...state, voc_filters: action.payload };

    case SET_CPO_OPERATIONAL_FILTERS:
      return { ...state, cpo_operational_filters: action.payload };

    case SET_ECOMMERCE_FILTERS:
      return { ...state, ecommerce_filters: action.payload };

    case SET_MSRP_FILTERS:
      return { ...state, msrp_filters: action.payload };

    case SET_JOURNEY_EXCLLENCE_FILTERS:
      return { ...state, journey_excellence_filters: action.payload };

    case SET_USE_OWNERSHIP_FILTERS:
      return { ...state, use_ownership_filters: action.payload };

    case SET_OCE_ALL_MARKET_REGIONS:
      return { ...state, oce_all_market_regions: action.payload };

    case SET_OCE_ALL_REGIONS:
      return { ...state, oce_all_regions: action.payload };

    case SET_OCE_MODEL_BY_BRAND_FILTERS:
      return { ...state, oce_model_by_brand_filters: action.payload };

    case SET_OCE_MARKETS_BY_BRAND_FILTERS:
      return { ...state, oce_markets_by_brand_filters: action.payload };

    case SET_OCE_CHANNELS_BY_BRAND_FILTERS:
      return { ...state, oce_channels_by_brand_filters: action.payload };

    case SET_BRAND_PERFORMANCE_VOLUME_FILTERS:
      return { ...state, brand_performance_volume_filters: action.payload };

    case SET_BRAND_PERFORMANCE_OAO_FILTERS:
      return { ...state, brand_performance_oao_filters: action.payload };

    case SET_BRAND_HEALTH_INDEX_FILTERS:
      return { ...state, brand_health_index_filters: action.payload };

    case SET_BUZZ_TRACKING_FILTERS:
      return { ...state, buzz_tracking_filters: action.payload };

    case SET_BRAND_PERFORMANCE_IMAGE_ATTRIBUTE_FILTERS:
      return { ...state, brand_performance_image_attribute_filters: action.payload };

    case SET_BRAND_SEGMENT_VOLUME_FILTERS:
      return { ...state, brand_segment_volume_filters: action.payload };

    case SET_EXECUTIVE_SUMMARY_FILTERS:
      return { ...state, executive_summary_filters: action.payload };

    case SET_BRAND_MARKET_SHARE_FILTERS:
      return { ...state, brand_market_share_filters: action.payload };

    case SET_SALES_BY_VOLUME_FILTERS:
      return { ...state, brand_sales_by_volume_filters: action.payload };

    case SET_BRAND_PERFORMANCE_SOV_SOM_FILTERS:
      return { ...state, brand_performance_sov_som_filters: action.payload };

    case SET_BRAND_KPI_TREND_FILTERS:
      return { ...state, brand_kpi_trend_filters: action.payload };

    case SET_BRAND_KPI_SUMMARY_FILTERS:
      return { ...state, brand_kpi_summary_filters: action.payload };

    case SET_BRAND_PERFORMANCE_PURCHASE_FUNNEL_FILTERS:
      return { ...state, brand_performance_purchase_funnel_filters: action.payload };

    case SET_BRAND_PERFORMANCE_IMAGE_SNAPSHOT_FILTERS:
      return { ...state, brand_performance_image_snapshot_filters: action.payload };

    case SET_MONTHLY_TABLE_FOR_DOWNLOAD_FILTERS:
      return { ...state, brand_performance_monthly_table_for_download_filters: action.payload };

    case SET_YEARLY_TABLE_FOR_DOWNLOAD_FILTERS:
      return { ...state, brand_performance_yearly_table_for_download_filters: action.payload };

    case SET_QUARTERLY_TABLE_FOR_DOWNLOAD_FILTERS:
      return { ...state, brand_performance_quarterly_table_for_download_filters: action.payload };

    case SET_BRAND_PERFORMANCE_NIM_FILTERS:
      return { ...state, brand_performance_nim_filters: action.payload };

    case SET_BRAND_PERFORMANCE_NIM_LATEST_FILTERS:
      return { ...state, brand_performance_nim_latest_filters: action.payload };

    case SET_BRAND_PERFORMANCE_RV_FILTERS:
      return { ...state, brand_performance_rv_filters: action.payload };

    case SET_BRAND_PERFORMANCE_TPVA_FILTERS:
      return { ...state, brand_performance_tpva_filters: action.payload };

    case SET_BRAND_PERFORMANCE_TECH_AWARENESS_FILTERS:
      return { ...state, brand_performance_tech_awareness_filters: action.payload };

    case SET_BRAND_PERFORMANCE_TP_FILTERS:
      return { ...state, brand_performance_tp_filters: action.payload };

    default:
      return state;
  }
};

export default filtersReducer;
